import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: ${rem(10)};
`;

export const StyledLabel = styled.label`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  font-weight: 600;
  margin-right: ${rem(8)};
`;

export const DropdownWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const StyledDropdown = styled.select`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray600};
  border-radius: ${rem(8)};
  color: ${({ theme, value }) => (value === undefined ? theme.colors.gray600 : theme.colors.gray900)};
  font-family: 'Open Sans';
  font-style: normal;
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  padding: ${rem(8)} ${rem(12)};
  width: 100%;

  /* hide default arrow icon */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.gray600};
    opacity: 1;
  }
`;

export const IconWrapper = styled.div`
  display: 'block';
  position: absolute;
  bottom: ${rem(4)};
  right: ${rem(8)};
  pointer-events: none;

  & svg {
    pointer-events: none;
  }
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.colors.red};
  font-weight: 400;
  font-size: ${rem(12)};
  font-family: 'Open Sans';
  margin-top: ${rem(8)};
  flex-wrap: wrap;
  max-width: fit-content;
`;
